import type { ProjectDetailResponse, ProjectProgressDeckPreview, ProjectRender } from "./project-types";
import { userFacingGenerationErrorCode, userFacingGenerationMessage } from "./user-facing-generation-message";

const ADVANCED_BEAUTIFY_PRODUCT_CODE = "advanced-beautify-image2";

export function latestFailedRender(detail?: ProjectDetailResponse): ProjectRender | undefined {
  return [...(detail?.renders || [])].reverse().find((render) => render.status === "failed");
}

export function latestFailedAdvancedBeautifyRender(detail?: ProjectDetailResponse): ProjectRender | undefined {
  return [...(detail?.renders || [])].reverse().find((render) =>
    render.status === "failed" && render.productCode === ADVANCED_BEAUTIFY_PRODUCT_CODE,
  );
}

export function hasCompletedStandardRender(detail?: ProjectDetailResponse): boolean {
  return Boolean(detail?.renders.some((render) =>
    render.status === "succeeded"
    && Boolean(render.outputManifest)
    && render.productCode !== ADVANCED_BEAUTIFY_PRODUCT_CODE
    && render.productCode !== "image2-slide-revision-preview",
  ));
}

export function projectFailureMode(detail?: ProjectDetailResponse): "advanced" | "standard" | undefined {
  if (hasCompletedStandardRender(detail) && (
    latestFailedAdvancedBeautifyRender(detail)
    || detail?.failureContext?.mode === "advanced_beautify"
    || detail?.task.failureStage === "advanced_beautify"
  )) return "advanced";
  return projectHasVisibleFailure(detail) ? "standard" : undefined;
}

export function failedProgressDeckPreview(detail?: ProjectDetailResponse): ProjectProgressDeckPreview | undefined {
  const preview = detail?.generationProgressDeckPreview || undefined;
  return preview?.status === "failed" ? preview : undefined;
}

export function projectHasVisibleFailure(detail?: ProjectDetailResponse, finalRender?: ProjectRender): boolean {
  if (!detail || finalRender) return false;
  const status = detail.task.status;
  if (status === "failed") return true;
  if (status === "planning" || status === "generating" || status === "succeeded") return false;
  return Boolean(
    detail.task.failureStage
    || detail.task.errorCode
    || detail.task.errorMessage
    || latestFailedRender(detail)
    || failedProgressDeckPreview(detail)?.renderError,
  );
}

export function projectFailureMessage(detail?: ProjectDetailResponse): string {
  return userFacingGenerationMessage(latestFailedAdvancedBeautifyRender(detail)?.errorMessage
    || detail?.failureContext?.errorMessage
    || detail?.task.errorMessage
    || failedProgressDeckPreview(detail)?.renderError
    || latestFailedRender(detail)?.errorMessage
    || "生成过程中出现异常");
}

export function projectFailureCode(detail?: ProjectDetailResponse): string | undefined {
  const code = latestFailedAdvancedBeautifyRender(detail)?.errorCode || detail?.failureContext?.errorCode || detail?.task.errorCode || latestFailedRender(detail)?.errorCode;
  return code ? userFacingGenerationErrorCode(code) : undefined;
}

export function projectFailureStage(detail?: ProjectDetailResponse): string | undefined {
  return detail?.task.failureStage;
}
